import { Validators } from '@angular/forms';
import { FormField } from '@adminprodigydesign/axis';
import { AccountNavItem } from './my-account.types';

export const ACCOUNT_SECTIONS: AccountNavItem[] = [
  { key: 'profile', label: 'Profile' },
  { key: 'security', label: 'Security' },
  { key: 'addresses', label: 'Addresses' },
  { key: 'orders', label: 'Orders' },
];

export const CHANGE_PASSWORD_INPUTS: FormField[] = [
  {
    name: 'oldPassword',
    label: 'Current Password',
    placeholder: 'Enter your current password',
    type: 'password',
    validators: [Validators.required],
  },
  {
    name: 'password',
    label: 'New Password',
    placeholder: 'Enter your new password',
    type: 'password',
    validators: [Validators.required],
  },
  {
    name: 'confirmPassword',
    label: 'Confirm New Password',
    placeholder: 'Confirm your new password',
    type: 'password',
    validators: [Validators.required],
  },
];

export const UPDATE_NAME_INPUTS: FormField[] = [
  {
    name: 'firstName',
    label: 'First name',
    placeholder: 'Enter your first name',
    type: 'text',
    validators: [Validators.required],
  },
  {
    name: 'lastName',
    label: 'Last name',
    placeholder: 'Enter your last name',
    type: 'text',
    validators: [Validators.required],
  },
];

export const UPDATE_PHONE_INPUTS: FormField[] = [
  {
    name: 'phoneNumber',
    label: 'Mobile number',
    placeholder: 'Enter your mobile number',
    type: 'tel',
    validators: [Validators.required],
  },
];
